import {Inject, Injectable, Injector} from "@angular/core";
import {
    HttpContextToken,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from "@angular/common/http";
import {Observable} from "rxjs";
import {HankoService} from "./hanko.service";
import {HANKO_AUTH_API_URL} from "./inj-token";

export const SOPI_SKIP_HTTP_AUTH_KEY = new HttpContextToken<boolean>(() => false);

@Injectable()
export class HankoAuthInterceptor implements HttpInterceptor {

    constructor(private hanko: HankoService,
                @Inject(HANKO_AUTH_API_URL) private baseUrl: string
    ) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.context && req.context.get(SOPI_SKIP_HTTP_AUTH_KEY).valueOf() === true)
            return next.handle(req);

        let requestToForward = req;

        if (req.url.startsWith(this.baseUrl)) {

            const authToken = this.hanko.getAccessToken();

            const newReq = req.clone({
                headers: req.headers.append('Authorization', `Bearer ${authToken}`),
            });

            return next.handle(newReq);

        }

        return next.handle(requestToForward);
    }
}
